import { Injectable } from '@angular/core';
import { AuthService } from 'ng2-ui-auth';
import { Observable } from 'rxjs/Rx';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { ProfilesService } from '../users/profiles-service';
import { User } from '../../models/user';
import { ENV } from '../../environments/environment';

@Injectable()
export class AuthenticationApi {

  profile(userRoles: boolean = false): Observable<any> {
    return Observable.create(observable => {
      this.storage.getItem("Profile")
        .subscribe(res => {
          let U = new User(res);
          observable.next(userRoles ? U.get("roles").map(function(R){ return R.name; }) : U);
        }, rej => observable.error("Unable to load profile"))
    })
  }
 
  login(credentials): Observable<any> {
    let self: AuthenticationApi = this;
    credentials.grant_type = "password";
    credentials.client_id = ENV.clientId;
    credentials.client_secret = ENV.clientSecret;
    return Observable.create(observable => {
      this.auth.login(credentials)
        .subscribe(res => {
          this.storage.setItem("token",res).subscribe(() => {
            this.profilesService.fetch().subscribe(Profile => {
              this.storage.setItem("Profile",Profile).subscribe(() => {
                setTimeout(function(){
                  self.auth.setToken(res.access_token);
                  observable.next(res);
                }, 1);
              })
            })
          });
        },
        rej => {
          if(rej.error.hasOwnProperty("error") && rej.error.error == "invalid_credentials") {
            observable.error({message: "Your email or password is invalid.  Please try again."});
          }
          else if(rej.error.hasOwnProperty("error") && rej.error.error == "invalid_client") {
            observable.error({message: "Your credentials are invalid.  Please try again."});
          }
          else {
            observable.error({message: "We were unable to log you in.  Please check your credentials & try again."});
          }
        }
      );
    });
  }

  forgot(email: string): Observable<any> {
    let self: AuthenticationApi = this;
    return Observable.create(observable => {
      self.http.post<any>(`${ENV.apiUrl}/profiles/forgot-password`,{email:email})
        .subscribe(
          res => { observable.next(res); },
          res => { observable.error(res.error); }
        );
    });
  }

  reset(credentials: object): Observable<any> {
    let self: AuthenticationApi = this;
    return Observable.create(observable => {
      self.http.post<any>(`${ENV.apiUrl}/profiles/reset-password`,credentials)
        .subscribe(
          res => { observable.next(res); },
          rej => { observable.error(rej.error); }
        );
    });
  }

  logout(): Observable<any> {
    return Observable.create(observable => {
      this.storage.removeItem("Profile").subscribe(() => {
        this.auth.logout()
          .subscribe(() => observable.complete(), () => observable.complete());
      });
    })
  }

  authenticate(provider): Observable<Response> {
    return this.auth.authenticate(provider).map(res => res.json());
  }

  getAccessToken() {
    return this.auth.getToken();
  }

  isAuthenticated() {
    return this.auth.isAuthenticated();
  }

  constructor(private auth: AuthService,
    private http: HttpClient,
    private storage: AsyncLocalStorage,
    private profilesService: ProfilesService) {}
}



// WEBPACK FOOTER //
// ./src/services/authentication/authentication-api.ts